import type { IconSvgObject } from './types';

const VenusAndMarsIcon: IconSvgObject = [
  ["path", { d: "M13.5 11C13.5 13.2091 11.7091 15 9.5 15C7.29086 15 5.5 13.2091 5.5 11C5.5 8.79086 7.29086 7 9.5 7C11.7091 7 13.5 8.79086 13.5 11Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12.5 8L18 2.5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9.5 15V22M7 19.5H12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M14 2.24891C14 2.24891 17.6909 1.68883 18.2511 2.24895C18.8112 2.80906 18.2511 6.5 18.2511 6.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default VenusAndMarsIcon;
